import {Injectable, signal} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private alert = signal('');
  readonly alertMessage = this.alert.asReadonly();

  showAlert(message: string) {
    this.alert.set(message);
  }
}
